import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { AdminOrganizationDetail, AdminOrganizationDetailState } from './types';

const initialState: AdminOrganizationDetailState = {
  organization: null,
  isLoading: false,
  isSaving: false,
  error: null,
  saveError: null
};

export const detailSlice = createSlice({
  name: 'adminOrganizationDetail',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    getOrganizationSuccess(state, action: PayloadAction<AdminOrganizationDetail>) {
      state.isLoading = false;
      state.organization = action.payload;
    },
    hasError(state, action: PayloadAction<string | null>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    startSaving(state) {
      state.isSaving = true;
      state.saveError = null;
    },
    saveSuccess(state, action: PayloadAction<AdminOrganizationDetail>) {
      state.isSaving = false;
      state.organization = action.payload;
    },
    saveError(state, action: PayloadAction<string | null>) {
      state.isSaving = false;
      state.saveError = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
    reset(state) {
      state.organization = null;
      state.isLoading = false;
      state.isSaving = false;
      state.error = null;
      state.saveError = null;
    }
  }
});

export default detailSlice.reducer;
